import { get } from 'lodash-es';

export const taskListErrorMessageSelector = (state) => get(state, ['taskList', 'errorMessage']);
export const yearSelector = (state) => get(state, ['taskList', 'taxYear']);
export const showAllReturnsSelector = (state) => get(state, ['taskList', 'showAllReturns']);
export const taskListOrderSelector = (state) => get(state, ['taskList', 'order']);
export const bulkEditModeSelector = (state) => get(state, ['taskList', 'bulkEditMode']);
export const bulkEditTasksSelector = (state) => get(state, ['taskList', 'bulkEditTasks']);
export const taskListFiltersSelector = (state) => get(state, ['taskList', 'filters']);
export const taskListCurrentTabSelector = (state) => get(state, ['taskList', 'currentTab']);
export const taskListPageNumberSelector = (state) => get(state, ['taskList', 'pageNumber']);
